import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { network } from '../config/blockchain';

import Log from '../utils/Log';

const styles = theme => ({
  root: {
    background: theme.palette.secondary.main,
    textAlign: 'center',
    padding: 10
  }
});

class NetworkCodeCheck extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }

  componentDidMount() {
    this.props.web3.eth.getCode(network.contracts.StickItemType.address, (error, code) => {
      if (error) {
        Log.error(`Failed when trying to get code: ${error}.`);
      } else {
        if ((code === '0x') || (code === '0x0')) {
          Log.error(`No code found at StickItem.address: ${network.contracts.StickItemType.address}`);
          this.setState({
            show: true
          });
        }
      }
    });
  }
  
  render() {
    const { classes } = this.props;

    if (this.state.show) {
      return (
        <Typography
          variant="subheading"
          className={classes.root}>
          Please change MetaMask to use the {network.name} network.
        </Typography>
      );
    } else {
      return null;
    }
  }
}

export default withStyles(styles)(NetworkCodeCheck);



// WEBPACK FOOTER //
// ./src/components/NetworkCodeCheck.js